import { useCallback } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { performPnpAutoLogin } from '../api/register/pnpAutoLogin';

const usePnpAutoLogin = () => {
  const { showBoundary } = useErrorBoundary();

  return useCallback(async () => {
    try {
      await performPnpAutoLogin();
    } catch (err) {
      showBoundary(err);
    }
  }, [showBoundary]);
};

export default usePnpAutoLogin;
